import React from "react";
import { Switch, Route } from "react-router-dom";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import Portal from "../pages/portal";
import DokumenPabean from "../pages/portal/dokumenPabean";
const PortalRouter = () => {
  return (
    <TransitionGroup>
      <CSSTransition classNames="fadein" timeout={300}>
        <Switch>
          <Route path="/portal/dokumen-pabean/:id" component={DokumenPabean} />
          <Route path="/portal/" component={Portal} />
        </Switch>
      </CSSTransition>
    </TransitionGroup>
  );
};

export default PortalRouter;
